document.addEventListener('DOMContentLoaded', function () {
  var $ = function (s) { return document.querySelector(s); };

  /* Search */
  var so = $('#search-overlay');
  if ($('#search-btn')) $('#search-btn').addEventListener('click', function () { so.classList.add('active'); });
  if ($('#close-search')) $('#close-search').addEventListener('click', function () { so.classList.remove('active'); });

  /* Cart drawer */
  var drawer = $('#cart-drawer'), bd = $('#drawer-backdrop');
  window.openCart  = function () { drawer.classList.add('open'); bd.classList.add('active'); };
  window.closeCart = function () { drawer.classList.remove('open'); bd.classList.remove('active'); };
  if ($('#cart-btn')) $('#cart-btn').addEventListener('click', window.openCart);
  if ($('#close-cart')) $('#close-cart').addEventListener('click', window.closeCart);
  if (bd) bd.addEventListener('click', window.closeCart);

  /* Account */
  if ($('#profile-btn')) $('#profile-btn').addEventListener('click', function () { window.location = '/account/login'; });

  /* Real Shopify cart */
  window.refreshCart = function () {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var badge = $('.cart-count-badge'); if (badge) badge.textContent = cart.item_count;
      var sub = $('#cart-subtotal'); if (sub) sub.textContent = 'Rs. ' + (cart.total_price / 100).toLocaleString();
      var body = $('#cart-body');
      if (!cart.items.length) { body.innerHTML = '<p class="empty-cart-text">Your bag is currently empty.</p>'; return; }
      body.innerHTML = cart.items.map(function (i) {
        return '<div class="cart-item" style="display:flex;justify-content:space-between;align-items:center;margin-bottom:15px;border-bottom:1px solid #eee;padding-bottom:10px;">' +
          '<div><h4 style="font-size:13px;color:#440512;font-family:\'Playfair Display\',serif;">' + i.product_title + '</h4>' +
          '<p style="font-size:12px;color:#6a3941;">' + i.quantity + ' × Rs. ' + (i.price / 100).toLocaleString() + '</p></div>' +
          '<button onclick="removeFromCart(\'' + i.key + '\')" style="background:none;border:none;font-size:20px;cursor:pointer;color:#440512;">&times;</button></div>';
      }).join('');
    });
  };

  window.addToCart = function (variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function () { return window.refreshCart(); }).then(window.openCart);
  };

  window.removeFromCart = function (key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function () { return window.refreshCart(); });
  };

  window.refreshCart();

  /* WhatsApp quick order */
  window.quickWhatsAppOrder = function (productName, price) {
    var m = '*NEW ORDER INQUIRY - VORA JEWELRY*%0A%0A*Product:* ' + productName + '%0A*Price:* ' + price +
      '%0A%0AHi VORA! I would like to place an order for this item. Please share payment and shipping details.';
    window.open('https://wa.me/923131282895?text=' + m, '_blank');
  };
});